<template>
    <div class="container">
        <div class="rundown-container">
            <div class="header">
                <h5> <strong> 27 November 2018  </strong></h5>
                <h6> <strong> IDNIC "WORKSHOP SESSION" Meeting Room Lantai 10 </strong> </h6>
            </div>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Waktu</th>
                        <th>Lokasi</th>
                        <th>Acara / Tema</th>
                        <th>Pembicara</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td> 08:00 - 08:30 </td>
                        <td> </td>
                        <td> Registrasi </td>
                        <td></td>
                    </tr>
                    <tr class="break">
                        <td>09:30 - 10:00</td>
                        <td colspan="" style="border-right:none !important;"> Lantai 10 </td>
                        <td colspan="2" style="border-left:none !important;"> Coffee Break </td>
                    </tr>
                    <tr>
                        <td rowspan="2">10.00 - 12.00</td>
                        <td> Ruang #1 </td>
                        <td> <strong> APNIC Training : Network Security (Intermediate) Session #1 </strong> </td>
                        <td> </td>
                    </tr>
                    <tr>
                        <td> Ruang #2 </td>
                        <td> <strong> IDCERT : CyberDrill Session #1 </strong> </td>
                        <td> </td>
                    </tr>
                    <tr class="break">
                        <td rowspan="2">12.00 - 13.00</td>
                        <td> Musholla, Lantai 10 </td>
                        <td rowspan="2" colspan="2"> ISHOMA & Lunch </td>
                    </tr>
                    <tr class="break">
                        <td> Lunch, Lantai 3 </td>
                    </tr>
                    <tr>
                        <td rowspan="2"> 13.00 - 15.00 </td>
                        <td> Ruang #1 </td>
                        <td>  <strong> APNIC Training : Network Security (Intermediate) Session #2 </strong> </td>
                        <td> </td>
                    </tr>
                    <tr>
                        <td> Ruang #2 </td>
                        <td> <strong>IDCERT : CyberDrillSession #2</strong> </td>
                        <td></td>
                    </tr>
                    <tr class="break">
                        <td> 15.30 15.30 </td>
                        <td> Lantai 10 </td>
                        <td colspan="2"> Coffee Break & ISHOMA </td>
                    </tr>
                    <tr>
                        <td> 15.30 - 17.30 </td>
                        <td> Ruang #1 </td>
                        <td> <strong> Introduction to 802.1x Protocol Enterprise Network </strong> </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td> 15.30 - 17.30 </td>
                        <td> Ruang #2 </td>
                        <td> <strong> Workshop PANDI </strong> </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="rundown-container">
            <div class="header">
                <h5> <strong> 28 November 2018  </strong></h5>
                <h6> <strong> IDNIC "WORKSHOP SESSION" Meeting Room Lantai 10 </strong> </h6>
            </div>
            <table class="table table-bordered" >
                <thead>
                    <tr>
                        <th>Waktu</th>
                        <th>Lokasi</th>
                        <th>Acara / Tema</th>
                        <th>Pembicara</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td> 08.00 - 09.30 </td>
                        <td>  </td>
                        <td> Registrasi </td>
                        <td></td>
                    </tr>
                    <tr class="break">
                        <td>09:30 - 10:00</td>
                        <td colspan="" style="border-right:none !important;"> Lantai 10 </td>
                        <td colspan="2" style="border-left:none !important;"> Coffee Break </td>
                    </tr>
                    <tr>
                        <td rowspan="2">10.00 - 12.00</td>
                        <td> Ruang #1 </td>
                        <td> <strong> APNIC Training : Network Security (Intermediate) Session #3 </strong> </td>
                        <td> </td>
                    </tr>
                    <tr>
                        <td> Ruang #2 </td>
                        <td> <strong> IDCERT : CyberDrill Session #1 </strong> </td>
                        <td> </td>
                    </tr>
                    <tr class="break">
                        <td rowspan="2">12.00 - 13.00</td>
                        <td> Musholla, Lantai 10 </td>
                        <td rowspan="2" colspan="2"> ISHOMA & Lunch </td>
                    </tr>
                    <tr class="break">
                        <td> Lunch, Lantai 3 </td>
                    </tr>
                    <tr>
                        <td rowspan="2"> 13.00 - 15.00 </td>
                        <td> Ruang #1 </td>
                        <td>  <strong> APNIC Training : Network Security (Intermediate) Session #4 </strong> </td>
                        <td> </td>
                    </tr>
                    <tr>
                        <td> Ruang #2 </td>
                        <td> <strong>IDCERT : CyberDrillSession #2</strong> </td>
                        <td></td>
                    </tr>
                    <tr class="break">
                        <td> 15.30 15.30 </td>
                        <td> Lantai 10 </td>
                        <td colspan="2"> Coffee Break & ISHOMA </td>
                    </tr>
                    <tr>
                        <td> 15.30 - 17.30 </td>
                        <td> Ruang #1 </td>
                        <td> <strong> Introduction to 802.1x Protocol Enterprise Network </strong> </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td> 15.30 - 17.30 </td>
                        <td> Ruang #2 </td>
                        <td> <strong>  MIKROTIK IPv6 by Harijanto </strong> </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <div class="rundown-container">
            <div class="header">
                <h5> <strong> 29 November 2018  </strong></h5>
                <h6> <strong> IDNIC "WORKSHOP SESSION" Meeting Room Lantai 10 </strong> </h6>
            </div>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Waktu</th>
                        <th>Lokasi</th>
                        <th>Acara / Tema</th>
                        <th>Pembicara</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>08.00 - 08.30</td>
                        <td></td>
                        <td> Registrasi </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td rowspan="2"> 08.30 - 10.00</td>
                        <td> Ruang #1 </td>
                        <td> <strong> APNIC Training : Network Security (Intermediate) Session #1 </strong></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Ruang #2</td>
                        <td> <strong> Sponsors Workshop </strong> </td>
                        <td></td>
                    </tr>
                    <tr class="break">
                        <td> 10.00 - 10.30 </td>
                        <td> Lantai #1 </td>
                        <td colspan="2"> Cofee Break </td>
                    </tr>
                    <tr>
                        <td rowspan="2"> 10.30 - 12.00 </td>
                        <td> Ruang #1 </td>
                        <td> <strong> APNIC Training : Network Security (Intermediate) Session #2 </strong> </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Ruang#2</td>
                        <td> <strong> Sponsors Workshop </strong> </td>
                        <td></td>
                    </tr>
                    <tr class="break">
                        <td rowspan="2"> 12.00 - 13.00 </td>
                        <td> Musholla, Lantai 10 </td>
                        <td rowspan="2" colspan="2"> Ishoma Lunch </td>
                    </tr>
                    <tr class="break">
                        <td>Lunch, Lantai 3</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="rundown-container">
            <div class="header">
                <h5> <strong> 29 November 2018  </strong></h5>
                <h6> <strong> OPM SESSION Ballroom Lantai 5 </strong> </h6>
            </div>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Waktu</th>
                        <th>Lokasi</th>
                        <th>Acara / Tema</th>
                        <th>Pembicara</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td> 08.00 - 08.30 </td>
                        <td> Foyer Ballroom </td>
                        <td> Registrasi </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td rowspan="5"> 08.30 - 09.30 </td>
                        <td rowspan="5"> Ballroom </td>
                        <td> 1. Menyanyikan Lagu Indonesia Raya </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td> 2. Laporan Ketua Panitia Pelaksana</td>
                        <td> </td>
                    </tr>
                    <tr>
                        <td>3. Kata Sambutan</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>4. <i> Ceremonial </i></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td> 5. Pembacaan Doa </td>
                        <td></td>
                    </tr>
                    <tr class="break">
                        <td> 09.30 - 10.00 </td>
                        <td> Ballroom </td>
                        <td colspan="2"> Coffee Break </td>
                    </tr>
                    <tr>
                        <td> 10.00 - 12.00</td>
                        <td>Ballroom</td>
                        <td>OPM Session</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td rowspan="2">12.00 - 14.00</td>
                        <td>Foyer Ballroom</td>
                        <td>ISHOMA & Lunch</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Ballroom</td>
                        <td>Clear Area (Persiapan untuk IDNIC Gathering)</td>
                        <td></td>
                    </tr>
                    
                    
                </tbody>
            </table>
        </div>

        <div class="rundown-container">
            <div class="header">
                <h5> <strong> 29 November 2018  </strong></h5>
                <h6> <strong> IDNIC "GATHERING SESSION" Ballroom Lantai 5 </strong> </h6>
            </div>

            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Waktu</th>
                        <th>Lokasi</th>
                        <th>Acara / Tema</th>
                        <th>Pembicara</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>14.00 - 14.30</td>
                        <td>Foyer Ballroom</td>
                        <td>Registrasi</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td> 14.30 - 16.00 </td>
                        <td> Ballroom </td>
                        <td> AMM Session #1 </td>
                        <td> Ketum APJII, Ketua IDNIC, APNIC, KOMINFO, BSSN </td>
                    </tr>
                    <tr class="break">
                        <td>16.00 - 16.30</td>
                        <td>Foyeh Ballroom</td>
                        <td colspan="2">ISHOMA & Coffee Break</td>
                    </tr>
                    <tr>
                        <td>16.30 - 18.00</td>
                        <td> Ballroom </td>
                        <td> AMM Session #2 </td>
                        <td> Indonesian Xchange (IIX, OIXP, CDIX, etc) <br> technical sharing session [moderator: HKS, Sammy, ], <br> IDCERT keynote + discussions, <br> IDSECONF keynote + discussions </td>
                    </tr>
                    <tr class="break">
                        <td>18.00 - 18.30</td>
                        <td colspan="3"> ISHOMA </td>
                    </tr>
                    <tr>
                        <td> 18.30 - 19.30 </td>
                        <td> Ballroom </td>
                        <td> AMM Session #3 </td>
                        <td> IDREN session, IDNIC members sharing session </td>
                    </tr>
                    <tr class="break">
                        <td> 19.30 - 20.30 </td>
                        <td> Foyeh Ballroom </td>
                        <td colspan="2"> Dinner  </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script>
export default {
    

}
</script>

<style lang="css" scoped>
    .rundown-container {
        margin-bottom: 40px;
    }

    .rundown-container .header {
        background-color: #1c3d5a;
        color:white;
        padding:20px 20px 8px 20px;
        display:block;
        border-radius: 10px 10px 0 0;
    }

    .rundown-container .header h6{
        padding:0;
        margin:0;
    }
    thead th{
        background-color: #51d88a;
    }
    tr.break td {
        background-color: #bcdefa;
        font-weight: bold;
        font-style: italic;
        vertical-align: center;
    }
</style>